import { useQuery } from '@tanstack/react-query'
import type { Client, GeographyLayerData } from '~/models'

type GeographiesResponse = {
  geographies: GeographyLayerData[]
}

export function useGeographies(client: Client) {
  const geographiesQuery = useQuery({
    queryKey: ['geographies', client.subdomain],
    queryFn: async () => {
      const response = await fetch('/api/geographies')
      return response.json() as Promise<GeographiesResponse>
    },
    refetchOnWindowFocus: false,
    enabled: client.layers_enabled,
  })
  const isLoading = geographiesQuery.isLoading

  return { geographies: geographiesQuery.data?.geographies ?? [], isLoading }
}
